// extracted by mini-css-extract-plugin
export default {"formGroup":"Input_formGroup__wHvW4","mandatory":"Input_mandatory__oGKzw"};